const translations = {
  fr: {
    history: {
      history: 'Historique',
      lastMonth: 'Dernier mois',
      lastThreeMonths: 'Dernier trois mois',
      lastSixMonths: 'Dernier six mois',
      lastYear: 'Dernière année',
      lastTwoYears: 'Deux dernières années',
      historyHasNoDataMessage: 'Veuillez réessayer avec un intervalle de temps plus long.',
      error: {
        title: 'Une erreur est survenue',
        message: 'Veuillez réessayer plus tard',
        buttonRetry: 'Réessayer',
      },
      dateRange: '{{from, DD MMMM YYYY}} au {{to, DD MMMM YYYY}}',
      weekDateRange: '{{from, DD MMMM}} au {{to, DD MMMM}}',
      reportCreatedOn: 'Rapport créé le : {{date, DD MMMM YYYY}}',
      weeksWillBeDisplayedHere: 'Les semaines ainsi que leur portée et leur temps d\'écoute apparaîtront ici.',
      interpolated: 'Ces données comportent une plus grande marge d\'erreur dû à un manque d\'échantillonnage.',
    },
  },
  en: {
    history: {
      history: 'History',
      lastMonth: 'Last Month',
      lastThreeMonths: 'Last Three Months',
      lastSixMonths: 'Last Six Months',
      lastYear: 'Last Year',
      lastTwoYears: 'Last Two Years',
      historyHasNoDataMessage: 'Please try again with a longer time period.',
      error: {
        title: 'Oops, an error has occured',
        message: 'Please try again later',
        buttonRetry: 'Retry',
      },
      dateRange: '{{from, MMMM DD, YYYY}} au {{to, MMMM DD, YYYY}}',
      weekDateRange: '{{from, MMMM DD}} to {{to, MMMM DD}}',
      reportCreatedOn: 'Report created on: {{date, MMMM DD, YYYY}}',
      weeksWillBeDisplayedHere: 'Weeks along with their reach and listening time will be displayed here.',
      interpolated: 'Due to a lack of sampling, these metrics might contain a larger margin of error.',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/i18n/history.js